import { REDUX_STORE } from '@funnels/constants';
import {
  ClearEmploymentsErrorAction,
  DeleteEmploymentsAction,
  DeleteEmploymentsFailAction,
  DeleteEmploymentsSuccessAction,
  FetchEmploymentsAction,
  FetchEmploymentsFailAction,
  FetchEmploymentsSuccessAction,
  ServerEmploymentFetch,
  ServerEmploymentUpdate,
  StoreEmployment,
  UpdateEmploymentsAbortAction,
  UpdateV2EmploymentsAction,
  UpdateV2EmploymentsFailAction,
  UpdateV2EmploymentsSuccessAction,
  UpsertV2EmploymentsAction,
  UpsertV2EmploymentsFailAction,
  UpsertV2EmploymentsSuccessAction,
} from '@funnels/types';

export function clearEmploymentsError(): ClearEmploymentsErrorAction {
  return { type: REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.CLEAR_EMPLOYMENTS_ERROR };
}

export function deleteEmployments(applicationId: string, clientId: string, id?: string): DeleteEmploymentsAction {
  return { type: REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.DELETE_EMPLOYMENTS, clientId, id, applicationId };
}

export function deleteEmploymentsFail(
  clientId: string,
  message: string = 'Unknown error'
): DeleteEmploymentsFailAction {
  return { type: REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.DELETE_EMPLOYMENTS_FAIL, clientId, message };
}

export function deleteEmploymentsSuccess(): DeleteEmploymentsSuccessAction {
  return { type: REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.DELETE_EMPLOYMENTS_SUCCESS };
}

export function fetchEmployments(applicationId: string, applicantId?: string): FetchEmploymentsAction {
  return { type: REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.FETCH_EMPLOYMENTS, applicationId, applicantId };
}

export function fetchEmploymentsFail(message: string = 'Unknown error'): FetchEmploymentsFailAction {
  return { type: REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.FETCH_EMPLOYMENTS_FAIL, message };
}

export function fetchEmploymentsSuccess(employments: ServerEmploymentFetch[]): FetchEmploymentsSuccessAction {
  return { type: REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.FETCH_EMPLOYMENTS_SUCCESS, employments };
}

export function updateEmploymentsAbort(): UpdateEmploymentsAbortAction {
  return { type: REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPDATE_EMPLOYMENTS_ABORT };
}

export function updateV2Employments(
  applicationId: string,
  employments: StoreEmployment[],
  applicantClientId: string,
  // this only need for api
  applicantId: string
): UpdateV2EmploymentsAction {
  return {
    type: REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPDATE_V2_EMPLOYMENTS,
    employments,
    applicationId,
    applicantClientId,
    applicantId,
  };
}

export function updateV2EmploymentsFail(message: string = 'Unknown error'): UpdateV2EmploymentsFailAction {
  return { type: REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPDATE_V2_EMPLOYMENTS_FAIL, message };
}

export function updateV2EmploymentsSuccess(
  employments: ServerEmploymentUpdate[],
  applicantClientId: string
): UpdateV2EmploymentsSuccessAction {
  return {
    type: REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPDATE_V2_EMPLOYMENTS_SUCCESS,
    employments,
    applicantClientId,
  };
}

export function upsertV2Employments(
  applicationId: string,
  employments: StoreEmployment[],
  applicantClientId: string,
  // this only need for api
  applicantId: string
): UpsertV2EmploymentsAction {
  return {
    type: REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPSERT_V2_EMPLOYMENTS,
    employments,
    applicationId,
    applicantClientId,
    applicantId,
  };
}

export function upsertV2EmploymentsFail(message: string): UpsertV2EmploymentsFailAction {
  return { type: REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPSERT_V2_EMPLOYMENTS_FAIL, message };
}

export function upsertV2EmploymentsSuccess(): UpsertV2EmploymentsSuccessAction {
  return { type: REDUX_STORE.EMPLOYMENTS.ACTION_TYPES.UPSERT_V2_EMPLOYMENTS_SUCCESS };
}
